import { DefaultFetchService } from "../fetchService";

interface IBaseSingleFunnelRequestParams {
    country: string;
    from: string;
    includeSubDomains: boolean;
    isWindow: boolean;
    segmentId: string;
    timeGranularity: string;
    to: string;
    webSource: string;
    keys: string;
    compareFrom?: string;
    compareTo?: string;
    lastUpdated?: string;
}

interface ISegmentUserFlowBucketPair {
    From: string;
    To: string;
    Value: {
        TotalBucketVisits: number;
        TotalPairVisits: number;
    };
}

interface ISegmentUserFlowResponse {
    GroupedByBucket: {
        B1: ISegmentUserFlowBucketPair[];
        B2: ISegmentUserFlowBucketPair[];
        B3: ISegmentUserFlowBucketPair[];
        B4: ISegmentUserFlowBucketPair[];
        B5: ISegmentUserFlowBucketPair[];
        B6: ISegmentUserFlowBucketPair[];
    };
}

interface ISegmentUserFlowApiService {
    getCustomSegmentUserFlowData: (params: IBaseSingleFunnelRequestParams) => Promise<ISegmentUserFlowResponse>;
}

export default class SegmentUserFlowApiService implements ISegmentUserFlowApiService {
    private static _instance;
    protected fetchService;

    constructor() {
        this.fetchService = DefaultFetchService.getInstance();
    }

    public static getInstance(): SegmentUserFlowApiService {
        if (!SegmentUserFlowApiService._instance) {
            SegmentUserFlowApiService._instance = new SegmentUserFlowApiService();
        }
        return SegmentUserFlowApiService._instance;
    }
    public getCustomSegmentUserFlowData = (
        params: IBaseSingleFunnelRequestParams,
    ): Promise<ISegmentUserFlowResponse> => {
        return this.fetchService.get("/widgetApi/segmentsUserFlow/data", {
            ...params,
            keys: "null",
            disableCache: true,
        });
    };
}
